import { render, staticRenderFns } from "./projectTag.vue?vue&type=template&id=ac73e5f8&"
import script from "./projectTag.vue?vue&type=script&lang=js&"
export * from "./projectTag.vue?vue&type=script&lang=js&"
import style0 from "./projectTag.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports